document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const openCartDrawer = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    const overlay = document.querySelector('[data-cart-overlay]');
    if (!drawer || !overlay) return;
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
    document.body.classList.add('cart-open');
  };

  const closeCartDrawer = () => {
    const drawer = document.querySelector('[data-cart-drawer]');
    const overlay = document.querySelector('[data-cart-overlay]');
    if (!drawer || !overlay) return;
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-visible');
    document.body.classList.remove('cart-open');
    window.setTimeout(() => { if (!overlay.classList.contains('is-visible')) overlay.hidden = true; }, 500);
  };

  const updateCartCounts = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    });
  };

  const refreshCartDrawer = async (shouldOpen = true) => {
    const sectionUrl = new URL(window.location.href);
    sectionUrl.searchParams.set('section_id', 'cart-drawer');
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(sectionUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }),
      fetch(`${document.body.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } })
    ]);
    if (!sectionResponse.ok || !cartResponse.ok) throw new Error('Winkelwagen kon niet worden vernieuwd.');
    const sectionHtml = await sectionResponse.text();
    const cart = await cartResponse.json();
    const container = document.querySelector('#shopify-section-cart-drawer');
    if (container) container.innerHTML = sectionHtml;
    updateCartCounts(cart);
    if (shouldOpen) requestAnimationFrame(openCartDrawer);
  };

  document.addEventListener('click', async (event) => {
    const galleryThumb = event.target.closest('[data-gallery-thumb]');
    if (galleryThumb) {
      event.preventDefault();
      const gallery = galleryThumb.closest('[data-product-gallery]');
      const mainImage = gallery?.querySelector('.product-gallery__main img');
      const imageUrl = galleryThumb.dataset.imageUrl;
      if (!mainImage || !imageUrl) return;

      mainImage.removeAttribute('srcset');
      mainImage.src = imageUrl;
      if (galleryThumb.dataset.imageAlt) mainImage.alt = galleryThumb.dataset.imageAlt;

      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
        const isActive = item === galleryThumb;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });
      return;
    }

    const opener = event.target.closest('[data-cart-open]');
    if (opener) {
      event.preventDefault();
      openCartDrawer();
      return;
    }
    if (event.target.closest('[data-cart-close]') || event.target.closest('[data-cart-overlay]')) {
      event.preventDefault();
      closeCartDrawer();
      return;
    }
    const changeButton = event.target.closest('[data-cart-change]');
    if (!changeButton) return;
    event.preventDefault();
    changeButton.disabled = true;
    try {
      const response = await fetch(`${document.body.dataset.cartChangeUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: changeButton.dataset.cartChange, quantity: Number(changeButton.dataset.quantity) })
      });
      if (!response.ok) throw new Error('Aantal kon niet worden aangepast.');
      await refreshCartDrawer(true);
    } catch (error) {
      window.alert(error.message);
      changeButton.disabled = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action]');
    if (!form) return;
    const action = new URL(form.action, window.location.origin).pathname;
    if (!action.endsWith('/cart/add')) return;
    if (event.submitter?.name === 'checkout') return;
    event.preventDefault();
    const submitter = event.submitter;
    if (submitter) submitter.disabled = true;
    try {
      const response = await fetch(`${document.body.dataset.cartAddUrl}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || 'Product kon niet worden toegevoegd.');
      }
      await refreshCartDrawer(true);
    } catch (error) {
      window.alert(error.message);
    } finally {
      if (submitter) submitter.disabled = false;
    }
  });

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="number"]');
    if (!input) return;
    wrapper.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const delta = Number(button.dataset.quantityChange || 0);
        const min = Number(input.min || 1);
        input.value = Math.max(min, Number(input.value || min) + delta);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const root = select.closest('[data-product-root]');
      if (!root || !option) return;
      const price = root.querySelector('[data-product-price]');
      const button = root.querySelector('[data-add-to-cart]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const stickyPrice = document.querySelector('[data-sticky-price]');
      const stickyVariant = document.querySelector('[data-sticky-variant]');
      if (stickyPrice && option.dataset.price) stickyPrice.textContent = option.dataset.price;
      if (stickyVariant) stickyVariant.value = option.value;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'In winkelwagen' : 'Uitverkocht';
      }
    });
  });

  document.querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
    const slides = [...carousel.querySelectorAll('[data-carousel-slide]')];
    const dots = [...carousel.querySelectorAll('[data-carousel-dot]')];
    let activeIndex = 0;
    const show = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeIndex));
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };
    carousel.querySelector('[data-carousel-prev]')?.addEventListener('click', () => show(activeIndex - 1));
    carousel.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(activeIndex + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.slideIndex))));
  });

  const productForm = document.querySelector('.product-info .product-form');
  const mobileSticky = document.querySelector('[data-mobile-sticky]');
  if (productForm && mobileSticky) {
    const stickyObserver = new IntersectionObserver(([entry]) => mobileSticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 });
    stickyObserver.observe(productForm);
  }

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  const reveal = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        reveal.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach((element) => reveal.observe(element));
});
